<template>
  <div class="video-wrapper">
    <div
      v-show="existVideo"
      ref="video"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></div>
    <div
      v-show="!loading && !existVideo"
      class="no-video-player"
      :style="{ width: tipsWidth }"
    >
      <!-- sultan 修改添加了 v-if="page != 'tril'-->
      <div class="no-video-error" v-if="page != 'tril'">
        <div class="no-video-errorIcon">
          <img src="../../assets/images/v3/nodata-video.png" />
        </div>
        <div v-if="page == 'study'" class="no-video-errorMessage">
          <template v-if="tipText">
            {{ tipText }}
          </template>
          <template v-else> 该班型视频正在准备中 </template>
        </div>
        <div v-else class="no-video-errorMessage">
          <template v-if="tipText">
            {{ tipText }}
          </template>
          <template v-else> 找不到该课程班型试看视频，请购买后观看 </template>
        </div>
      </div>
    </div>
    <!-- <Spin
      size="large"
      fix
      v-if="loading"
    ></Spin> -->
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { study } from '../../request';
import rsa from '../../utils/rsa.js';
export default {
  mixins: [siteMixin],
  props: {
    width: {
      type: Number,
      default: 875,
    },
    height: {
      type: Number,
      default: 500,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
    viewType: {
      type: String,
      default: '',
    },
    viewId: {
      type: [Number, String],
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    page: {
      type: String,
      default: '',
    },
    tipText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      existCourseCat: true,
      existVideo: true,
      tipsWidth: '1200px',
      realPlayTime: 0,
    };
  },
  computed: {
    viewerId() {
      if (this.viewType == 'review') {
        if (this.viewId.toString().match(/^u/)) {
          return this.viewId.replace('u', ''); // 串讲中的直播回放判断，传用户Id
        } else {
          return `r${this.viewId}`;
        }
      } else {
        return this.viewId.toString();
      }
    },
  },
  watch: {
    videoId() {
      this.realPlayTime = 0;
      this.runPlayer();
    },
    courseCatalog() {
      if (this.courseCatalog.length > 0) {
        this.existCourseCat = true;
        this.tipsWidth = this.width + 'px';
      } else {
        this.existCourseCat = false;
        if (this.page === 'study') {
          this.tipsWidth = '1125px';
        } else {
          this.tipsWidth = '1200px';
        }
      }
    },
  },
  mounted() {
    if (this.page === 'study') {
      this.tipsWidth = '1125px';
    } else {
      this.tipsWidth = '1200px';
    }
    this.runPlayer();
    console.clear = () => {};
  },
  beforeDestroy() {
    this.setVideoId('');
    if (this.finishTime) {
      clearInterval(this.finishTime);
    }
  },
  methods: {
    runPlayer() {
      if (this.player) {
        this.changePlayer();
      } else {
        this.initPlayer();
      }

      //无视频时提示视频制作中
      if (this.videoId && this.videoId !== 'onlyLive') {
        this.existVideo = true;
      } else {
        this.existVideo = false;
        if (this.videoId === 'onlyLive') {
          this.tipsWidth = '800px';
        }
      }
    },
    decrypt(value) {
      return rsa.decrypt(value);
    },
    initPlayer() {
      if (this.videoId) {
        study.getVideoPlayToken(this.videoId).then((res) => {
          console.log('videoCode', res);
          if (res.status == 1) {
            this.token = this.decrypt(res.data);
            this.loadPlayer();
          }
        });
      }
    },
    changePlayer() {
      if (this.player && this.videoId) {
        study.getVideoPlayToken(this.videoId).then((res) => {
          if (res.status == 1) {
            this.token = this.decrypt(res.data);

            try {
              this.player.destroy(); //部分浏览器出现异常，存在兼容性问题
            } catch (err) {}
            this.loadPlayer();
            // // 解决changeVid的bug问题（非加密切到加密视频，不能拖动进度的问题）
            // try {
            //   this.player.destroy(); //部分浏览器出现异常，存在兼容性问题
            // } catch (err) {
            //   this.player.j2s_stopVideo();
            //   this.$refs.video.innerHTML = '';
            // }
            // this.loadPlayer();

            // let viewerName = this.isLogin ? this.loginUser.userName : '';
            // if (!viewerName) {
            //   viewerName = localStorage.getItem('liveName') || '';
            // }

            // const option = {
            //   vid: this.videoId,
            //   playsafe: this.token,
            //   autoplay: true,
            //   // preview: !this.isBuy,
            //   viewerInfo: {
            //     viewerId: this.viewerId,
            //     viewerName,
            //   },
            // };
            // this.player.changeVid(option);
            // this.playerInitOver();
            // this.playOver();
          }
        });
      }
    },
    loadPlayer() {
      let viewerName = this.isLogin ? this.loginUser.userName : '';
      if (!viewerName) {
        viewerName = localStorage.getItem('liveName') || '';
      }

      const waterMap = {
        1: 'top-left',
        2: 'top-right',
        3: 'bottom-left',
        4: 'bottom-right',
      };
      const waterPosition = waterMap[this.siteConfig.waterMarkPosition];

      this.player = new BPlayer({
        container: this.$refs.video,
        memory: true, // 是否开启记忆播放
        vid: this.videoId, // 百家云后台视频id
        // vid: 189364561, // 百家云后台视频id
        token: this.token, // 视频id 对应token
        autoplay: this.autoPlay,
        // enableDrag: this.polyvParams.isFinish === 1 || progressBar === 1, // 是否允许拖拽进度条
        // maxWatchTime: 3600, // 最大可拖拽观看时间，单位秒，时间点之前可以拖动，之后不可以拖动
        enableMarquee: true, // 显示跑马灯
        enableWaterMark: !!this.siteConfig.waterMark, // 显示水印
        useFFplayerMSE: true, // 兼容低版本设备
        plugins: {
          waterMark: {
            url: this.concatImageUrl(this.siteConfig.waterMark), // 水印图片地址
            position: waterPosition, // 水印可设置四个角落定位 top-left || top-right || bottom-left || bottom-right
          },
          // marquee: {
          //   position: 'random',
          //   value: this.isLogin ? this.loginUser.userId.toString() : '0',
          //   // displayMode: 'blink',
          //   rollDuration: 20, // 滚动间隔时长 单位秒
          //   // blinkDuration: 30, // 闪烁间隔时长 单位秒
          //   count: 1, // 跑马灯单双数 1 单数 2 双数
          //   color: '#ffffff',
          //   backgroundColor: '#000000', // 跑马灯背景色 默认#1795ff
          //   backgroundOpacity: 0.01, // 跑马灯背景透明度 0.01 - 1
          //   fontSize: 18, // 跑马灯字体大小 单位px
          //   fontOpacity: 0.2, // 跑马灯透明度 0.01 - 1
          // },
        },
        user: {
          name: `${viewerName}`,
          number: `${this.viewerId}`,
        },
      });
      // this.player = polyvPlayer({
      //   wrap: this.$refs.video,
      //   width: this.width,
      //   height: this.height,
      //   autoplay: this.autoPlay,
      //   vid: this.videoId,
      //   playmode: 0,
      //   playsafe: this.token,
      //   forceH5: true,
      //   logo: {
      //     logo_url: this.concatImageUrl(this.siteConfig.waterMark),
      //     logo_pos: this.siteConfig.waterMarkPosition,
      //   },
      //   // preview: !this.isBuy,
      //   code: this.isLogin ? this.loginUser.userId.toString() : '0',
      //   viewerInfo: {
      //     viewerId: this.viewerId,
      //     viewerName,
      //     viewerAvatar: '',
      //   },
      //   rightMenu: [],
      // });
      this.playerInitOver();
      // 更新真实时长
      this.player.on('timeupdate', () => {
        this.realPlayTime++;
      });
      this.playOver();
    },
    playerInitOver() {
      if (!this.player) return;
      this.player.on('ready', () => {
        this.$emit('on-start');
        this.$emit('ready', this.player);
        const videoTime = this.player.duration;
        const overTime = parseInt(
          videoTime * (this.siteConfig.rateViewPpt / 100)
        );
        //if (this.initOver) return;
        //this.initOver = true;
        if (this.finishTime) {
          clearInterval(this.finishTime);
        }
        this.finishTime = setInterval(() => {
          let totalTime = this.realPlayTime;
          console.log('totalTime', totalTime, overTime, videoTime);
          if (totalTime < overTime) return;
          this.$emit('on-over');
          //this.initOver = false;
          clearInterval(this.finishTime);
        }, 2000);
      });
      // window.s2j_onPlayerInitOver = () => {
      //   this.$emit('on-start');
      //   const videoTime = this.player.j2s_getDuration();
      //   const overTime = parseInt(
      //     videoTime * (this.siteConfig.rateViewPpt / 100)
      //   );
      //   //if (this.initOver) return;
      //   //this.initOver = true;
      //   if (this.finishTime) {
      //     clearInterval(this.finishTime);
      //   }
      //   this.finishTime = setInterval(() => {
      //     let totalTime = this.player.j2s_realPlayVideoTime();
      //     console.log('totalTime', totalTime, overTime, videoTime);
      //     if (totalTime < overTime) return;
      //     this.$emit('on-over');
      //     //this.initOver = false;
      //     clearInterval(this.finishTime);
      //   }, 2000);
      // };
    },
    playOver() {
      this.player.on('ended', () => {
        if (this.playList.length == 0) return;
        console.log(this.playList);
        // console.log(this);
        const videoItem = this.playList.find((m) => m.videoId == this.videoId);
        if (!videoItem) return;
        let currentVideoIndex = this.playList.indexOf(videoItem);
        if (currentVideoIndex < this.playList.length - 1) {
          const current = this.playList[currentVideoIndex + 1];
          this.setCatalogId(current.catId || 0);
          this.setPptId(current.pptId);
          this.setVideoId(current.videoId);
        }
      });
      // window.s2j_onPlayOver = () => {
      //   if (this.playList.length == 0) return;
      //   console.log(this.playList);
      //   console.log(this);
      //   const videoItem = this.playList.find((m) => m.videoId == this.videoId);
      //   if (!videoItem) return;
      //   let currentVideoIndex = this.playList.indexOf(videoItem);
      //   if (currentVideoIndex < this.playList.length - 1) {
      //     const current = this.playList[currentVideoIndex + 1];
      //     this.setCatalogId(current.catId || 0);
      //     this.setPptId(current.pptId);
      //     this.setVideoId(current.videoId);
      //   }
      // };
    },
  },
};
</script>

<style lang="less" scoped>
.video-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  /deep/ .pv-logo {
    & > a {
      pointer-events: none;
    }
  }
  /deep/ .bplayer-watermark-wrap {
    max-width: 120px;
    max-height: 120px;
    width: auto !important;
    height: auto !important;
  }
}
.no-video-player {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;
  height: 100%;
  margin: 0;
  background: #00101b;
  direction: ltr;
  text-align: center;
  position: relative;
  z-index: 2;
  .no-video-error {
    text-align: center;
    display: inline-block;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    .no-video-errorIcon {
      display: inline-block;
      width: 280px;
      height: 200px;
    }
    .no-video-errorMessage {
      margin-top: 1px;
    }
  }
}
</style>
